/**
 * Extracts a user-friendly error message from various error types
 * @param err - The error object (can be Error, string, axios-like error, or unknown)
 * @returns A formatted error message string
 */
export function getErrorMessage(err: unknown): string {
  if (!err) return "Something went wrong. Please try again.";

  if (typeof err === "string") return err;

  if (err instanceof Error) return err.message;

  // Handle axios-like errors
  if (err && typeof err === "object" && "response" in err) {
    const apiError = err as {
      response?: {
        data?: { message?: string; error?: string };
        status?: number;
        statusText?: string;
      };
    };
    if (apiError.response?.data?.message) {
      return apiError.response.data.message;
    }
    if (apiError.response?.data?.error) {
      return apiError.response.data.error;
    }
    if (apiError.response?.statusText) {
      return `${apiError.response.status}: ${apiError.response.statusText}`;
    }
  }

  return "Something went wrong. Please try again.";
}
